const SCRAMBLE_PHASES = {
  headings: false,
  buttons: false,
  desktopMenu: false,
  megaMenu: false,
  dropdownLinks: true,
};

const TARGET_GROUPS = {
  headings: '.text-block:is(.h1, .h2, .h3, .h4, .h5, .h6)',
  buttons: '.button:not(.clear-filter):not(.scramble-disable), .button-secondary:not(.clear-filter):not(.scramble-disable)',
  desktopMenu: '.menu-list__link-title',
  megaMenu: '.mega-menu__link .wrap-text',
  dropdownLinks:
    '.mega-menu__list--products-grouped .mega-menu__link .wrap-text, .mega-menu__list--archives .mega-menu__link .wrap-text, .footer-mega-nav__link .wrap-text',
};

const PRODUCT_CARD_SELECTOR = 'product-card.product-card';
const PRODUCT_CARD_TITLE_HOOK_SELECTOR = '[data-scramble-product-card-title]';
const COLLECTION_CARD_SELECTOR = '.collection-card';
const COLLECTION_CARD_TITLE_HOOK_SELECTOR = '[data-scramble-collection-card-title]';
const MEGA_MENU_PRODUCT_PREVIEW_CARD_SELECTOR =
  '.mega-menu__content-list--products .resource-card[data-resource-type="product"]';
const MEGA_MENU_PRODUCT_PREVIEW_TITLE_SELECTOR = '.resource-card__title';
const SCRAMBLE_FONT_FAMILY = 'Droidobesh Depot';
const SCRAMBLE_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ012345678';
const SCRAMBLE_UPDATE_PROBABILITY_START = 0.68;
const SCRAMBLE_UPDATE_PROBABILITY_END = 0.42;
const SCRAMBLE_PROFILES = {
  button: {
    duration: 240,
    frameInterval: 24,
    delay: 0,
    maxScrambleFraction: 0.28,
    minScrambleChars: 1,
    maxScrambleChars: 2,
    easing: easeInOutCubic,
    resolveBias: 1.18,
  },
  'dropdown-link': {
    duration: 200,
    frameInterval: 24,
    delay: 0,
    maxScrambleFraction: 0.24,
    minScrambleChars: 1,
    maxScrambleChars: 3,
    easing: easeOutCubic,
    resolveBias: 1,
  },
  'product-card-title': {
    duration: 260,
    frameInterval: 26,
    delay: 55,
    maxScrambleFraction: 0.38,
    minScrambleChars: 2,
    maxScrambleChars: 5,
    easing: easeOutCubic,
    resolveBias: 1,
  },
  'mobile-drawer-link': {
    duration: 280,
    frameInterval: 24,
    delay: 0,
    maxScrambleFraction: 0.18,
    minScrambleChars: 1,
    maxScrambleChars: 2,
    easing: easeOutCubic,
    resolveBias: 1,
  },
};
const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
const mobileDrawerQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const MOBILE_DRAWER_ACCORDION_SELECTOR = 'header-drawer accordion-custom > details';
const MOBILE_DRAWER_LINK_TEXT_SELECTOR =
  '.details-content a.menu-drawer__menu-item[href] .menu-drawer__menu-item-text.wrap-text';
const targetSelector = Object.entries(SCRAMBLE_PHASES)
  .filter(([, isActive]) => isActive)
  .map(([group]) => TARGET_GROUPS[group])
  .filter(Boolean)
  .join(',');

let scrambleFontReady = false;
const activeScrambles = new WeakMap();
const mobileDrawerAccordionScrambled = new WeakSet();
let activeProductCard = null;
let activeProductCardTitle = null;
let activeCollectionCard = null;
let activeCollectionCardTitle = null;
let activeMegaMenuProductPreviewCard = null;
let activeMegaMenuProductPreviewTitle = null;

if (targetSelector && hoverQuery.matches && !reducedMotionQuery.matches) {
  document.documentElement.classList.add('scramble-text-enabled');
  loadScrambleFont();
  document.addEventListener('pointerover', handlePointerOver);
  document.addEventListener('pointerout', handlePointerOut);
  document.addEventListener('pointercancel', handlePointerOut);
  document.addEventListener('pointerover', handleProductCardPointerOver);
  document.addEventListener('pointerout', handleProductCardPointerOut);
  document.addEventListener('pointercancel', handleProductCardPointerOut);
  document.addEventListener('pointerover', handleCollectionCardPointerOver);
  document.addEventListener('pointerout', handleCollectionCardPointerOut);
  document.addEventListener('pointercancel', handleCollectionCardPointerOut);
  document.addEventListener('pointerover', handleMegaMenuProductPreviewPointerOver);
  document.addEventListener('pointerout', handleMegaMenuProductPreviewPointerOut);
  document.addEventListener('pointercancel', handleMegaMenuProductPreviewPointerOut);
  document.addEventListener('focusin', handleFocusIn);
  document.addEventListener('focusout', handleFocusOut);
  document.addEventListener('click', handleClick, true);
}

if (mobileDrawerQuery.matches && !reducedMotionQuery.matches) {
  document.documentElement.classList.add('scramble-text-enabled');
  loadScrambleFont();
  initializeMobileDrawerAccordionScramble();
}

function handlePointerOver(event) {
  const target = getTargetFromEvent(event);

  if (!target || isInsideTarget(target, event.relatedTarget)) return;

  startScramble(target, getScrambleProfileForElement(target));
}

function handlePointerOut(event) {
  const target = getTargetFromEvent(event);

  if (!target || isInsideTarget(target, event.relatedTarget)) return;

  restoreTarget(target);
}

function handleFocusIn(event) {
  const target = getTargetFromEvent(event);
  const productCardTitleTarget = getProductCardTitleFromEvent(event);
  const collectionCardTitleTarget = getCollectionCardTitleFromEvent(event);
  const megaMenuProductPreviewTitleTarget = getMegaMenuProductPreviewTitleFromEvent(event);

  if (target) startScramble(target, getScrambleProfileForElement(target));
  if (productCardTitleTarget) {
    activeProductCard = getProductCardFromEvent(event);
    activeProductCardTitle = productCardTitleTarget;
    startScramble(productCardTitleTarget, SCRAMBLE_PROFILES['product-card-title']);
  }
  if (collectionCardTitleTarget) {
    activeCollectionCard = getCollectionCardFromEvent(event);
    activeCollectionCardTitle = collectionCardTitleTarget;
    startScramble(collectionCardTitleTarget, SCRAMBLE_PROFILES['product-card-title']);
  }
  if (megaMenuProductPreviewTitleTarget) {
    activeMegaMenuProductPreviewCard = getMegaMenuProductPreviewCardFromEvent(event);
    activeMegaMenuProductPreviewTitle = megaMenuProductPreviewTitleTarget;
    startScramble(megaMenuProductPreviewTitleTarget, SCRAMBLE_PROFILES['product-card-title']);
  }
}

function handleFocusOut(event) {
  const target = getTargetFromEvent(event);
  const productCardTitleTarget = getProductCardTitleFromEvent(event);
  const collectionCardTitleTarget = getCollectionCardTitleFromEvent(event);
  const megaMenuProductPreviewTitleTarget = getMegaMenuProductPreviewTitleFromEvent(event);

  if (target) restoreTarget(target);
  if (productCardTitleTarget) restoreActiveProductCardTitle();
  if (collectionCardTitleTarget) restoreActiveCollectionCardTitle();
  if (megaMenuProductPreviewTitleTarget) restoreActiveMegaMenuProductPreviewTitle();
}

function handleClick(event) {
  const target = getTargetFromEvent(event);
  const productCardTitleTarget = getProductCardTitleFromEvent(event);
  const collectionCardTitleTarget = getCollectionCardTitleFromEvent(event);
  const megaMenuProductPreviewTitleTarget = getMegaMenuProductPreviewTitleFromEvent(event);

  if (target) restoreTarget(target);
  if (productCardTitleTarget) restoreActiveProductCardTitle();
  if (collectionCardTitleTarget) restoreActiveCollectionCardTitle();
  if (megaMenuProductPreviewTitleTarget) restoreActiveMegaMenuProductPreviewTitle();
}

function initializeMobileDrawerAccordionScramble() {
  const setup = () => {
    const accordions = document.querySelectorAll(MOBILE_DRAWER_ACCORDION_SELECTOR);

    accordions.forEach((details) => {
      if (!(details instanceof HTMLDetailsElement) || details.dataset.mobileDrawerScrambleBound === 'true') return;

      details.dataset.mobileDrawerScrambleBound = 'true';

      if (details.open) {
        mobileDrawerAccordionScrambled.add(details);
      }

      details.addEventListener('toggle', handleMobileDrawerAccordionToggle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
    return;
  }

  setup();
}

function handleMobileDrawerAccordionToggle(event) {
  const details = event.currentTarget;

  if (!(details instanceof HTMLDetailsElement)) return;

  if (!details.open) {
    mobileDrawerAccordionScrambled.delete(details);
    return;
  }

  if (mobileDrawerAccordionScrambled.has(details)) return;

  mobileDrawerAccordionScrambled.add(details);
  scrambleMobileDrawerLinks(details);
}

function scrambleMobileDrawerLinks(details) {
  const linkTargets = [...details.querySelectorAll(MOBILE_DRAWER_LINK_TEXT_SELECTOR)]
    .map((candidate) => (candidate instanceof HTMLElement ? getEnhanceableTextElement(candidate) : null))
    .filter(Boolean);

  linkTargets.forEach((target) => {
    startScramble(target, SCRAMBLE_PROFILES['mobile-drawer-link']);
  });
}

function handleProductCardPointerOver(event) {
  const card = getProductCardFromEvent(event);

  if (!card || activeProductCard === card || isInsideTarget(card, event.relatedTarget)) return;

  restoreActiveProductCardTitle();

  const titleTarget = getProductCardTitleTarget(card);

  if (!titleTarget) return;

  activeProductCard = card;
  activeProductCardTitle = titleTarget;
  startScramble(titleTarget, SCRAMBLE_PROFILES['product-card-title']);
}

function handleProductCardPointerOut(event) {
  const card = getProductCardFromEvent(event);

  if (!card || isInsideTarget(card, event.relatedTarget)) return;

  if (activeProductCard === card) restoreActiveProductCardTitle();
}

function handleCollectionCardPointerOver(event) {
  const card = getCollectionCardFromEvent(event);

  if (!card || activeCollectionCard === card || isInsideTarget(card, event.relatedTarget)) return;

  restoreActiveCollectionCardTitle();

  const titleTarget = getCollectionCardTitleTarget(card);

  if (!titleTarget) return;

  activeCollectionCard = card;
  activeCollectionCardTitle = titleTarget;
  startScramble(titleTarget, SCRAMBLE_PROFILES['product-card-title']);
}

function handleCollectionCardPointerOut(event) {
  const card = getCollectionCardFromEvent(event);

  if (!card || isInsideTarget(card, event.relatedTarget)) return;

  if (activeCollectionCard === card) restoreActiveCollectionCardTitle();
}

function handleMegaMenuProductPreviewPointerOver(event) {
  const card = getMegaMenuProductPreviewCardFromEvent(event);

  if (!card || activeMegaMenuProductPreviewCard === card || isInsideTarget(card, event.relatedTarget)) return;

  restoreActiveMegaMenuProductPreviewTitle();

  const titleTarget = getMegaMenuProductPreviewTitleTarget(card);

  if (!titleTarget) return;

  activeMegaMenuProductPreviewCard = card;
  activeMegaMenuProductPreviewTitle = titleTarget;
  startScramble(titleTarget, SCRAMBLE_PROFILES['product-card-title']);
}

function handleMegaMenuProductPreviewPointerOut(event) {
  const card = getMegaMenuProductPreviewCardFromEvent(event);

  if (!card || isInsideTarget(card, event.relatedTarget)) return;

  if (activeMegaMenuProductPreviewCard === card) restoreActiveMegaMenuProductPreviewTitle();
}

function getTargetFromEvent(event) {
  if (!(event.target instanceof Element)) return null;

  const candidate = event.target.closest(targetSelector);

  if (!candidate || !(candidate instanceof HTMLElement)) return null;

  return getEnhanceableTextElement(candidate);
}

function getProductCardFromEvent(event) {
  if (!(event.target instanceof Element)) return null;

  const card = event.target.closest(PRODUCT_CARD_SELECTOR);

  return card instanceof HTMLElement ? card : null;
}

function getProductCardTitleFromEvent(event) {
  const card = getProductCardFromEvent(event);

  return card ? getProductCardTitleTarget(card) : null;
}

function getCollectionCardFromEvent(event) {
  if (!(event.target instanceof Element)) return null;

  const card = event.target.closest(COLLECTION_CARD_SELECTOR);

  return card instanceof HTMLElement ? card : null;
}

function getCollectionCardTitleFromEvent(event) {
  const card = getCollectionCardFromEvent(event);

  return card ? getCollectionCardTitleTarget(card) : null;
}

function getMegaMenuProductPreviewCardFromEvent(event) {
  if (!(event.target instanceof Element)) return null;

  const card = event.target.closest(MEGA_MENU_PRODUCT_PREVIEW_CARD_SELECTOR);

  if (!(card instanceof HTMLElement)) return null;

  const megaMenuGrid = card.closest('.mega-menu__grid');

  return megaMenuGrid?.querySelector('.mega-menu__list--products-grouped') ? card : null;
}

function getMegaMenuProductPreviewTitleFromEvent(event) {
  const card = getMegaMenuProductPreviewCardFromEvent(event);

  return card ? getMegaMenuProductPreviewTitleTarget(card) : null;
}

function getProductCardTitleTarget(card) {
  const titleHook = card.querySelector(PRODUCT_CARD_TITLE_HOOK_SELECTOR);

  if (!(titleHook instanceof HTMLElement)) return null;

  return getEnhanceableTextElement(titleHook);
}

function getCollectionCardTitleTarget(card) {
  const titleHook = card.querySelector(COLLECTION_CARD_TITLE_HOOK_SELECTOR);

  if (!(titleHook instanceof HTMLElement)) return null;

  return getEnhanceableTextElement(titleHook);
}

function getMegaMenuProductPreviewTitleTarget(card) {
  const title = card.querySelector(MEGA_MENU_PRODUCT_PREVIEW_TITLE_SELECTOR);

  if (!(title instanceof HTMLElement)) return null;

  return getEnhanceableTextElement(title);
}

function restoreActiveProductCardTitle() {
  if (activeProductCardTitle) restoreTarget(activeProductCardTitle);

  activeProductCard = null;
  activeProductCardTitle = null;
}

function restoreActiveCollectionCardTitle() {
  if (activeCollectionCardTitle) restoreTarget(activeCollectionCardTitle);

  activeCollectionCard = null;
  activeCollectionCardTitle = null;
}

function restoreActiveMegaMenuProductPreviewTitle() {
  if (activeMegaMenuProductPreviewTitle) restoreTarget(activeMegaMenuProductPreviewTitle);

  activeMegaMenuProductPreviewCard = null;
  activeMegaMenuProductPreviewTitle = null;
}

function getEnhanceableTextElement(candidate) {
  if (shouldSkip(candidate)) return null;

  if (isSimpleTextElement(candidate)) return candidate;

  const elementChildren = [...candidate.children].filter((child) => child instanceof HTMLElement);
  const directText = [...candidate.childNodes]
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent.trim())
    .join('');

  if (directText || elementChildren.length !== 1) return null;

  const child = elementChildren[0];

  if (!(child instanceof HTMLElement) || shouldSkip(child) || !isSimpleTextElement(child)) return null;

  return child;
}

function isSimpleTextElement(element) {
  if (element.children.length > 0) return false;

  const text = element.textContent?.trim();

  return Boolean(text);
}

function shouldSkip(element) {
  if (element.hidden || element.closest('[hidden], [aria-hidden="true"]')) return true;
  if (element.closest('.scramble-disable')) return true;
  if (isProductValueIconCardText(element)) return true;
  if (element.matches('input, textarea, select, option, svg, img, picture, video, canvas')) return true;
  if (element.querySelector('input, textarea, select, option, svg, img, picture, video, canvas')) return true;

  const style = window.getComputedStyle(element);

  return style.display === 'none' || style.visibility === 'hidden';
}

function isProductValueIconCardText(element) {
  if (!element.closest('main[data-template*="product"]')) return false;

  const valueCard = element.closest('.group-block');

  return Boolean(valueCard?.querySelector('.icon-block__media'));
}

function isInsideTarget(target, relatedTarget) {
  return relatedTarget instanceof Node && target.contains(relatedTarget);
}

function getScrambleProfileForElement(target) {
  if (target.closest('.button, .button-secondary')) {
    return SCRAMBLE_PROFILES.button;
  }

  return SCRAMBLE_PROFILES['dropdown-link'];
}

function startScramble(target, profile = SCRAMBLE_PROFILES.button) {
  if (activeScrambles.has(target)) restoreTarget(target);

  const originalText = target.textContent;

  if (!originalText || !originalText.trim()) return;

  target.classList.add('scramble-target', 'is-scrambling');

  if (scrambleFontReady) {
    target.classList.add('scramble-font-ready');
  }

  const state = {
    originalText,
    startTime: performance.now(),
    timeoutId: null,
    delayTimeoutId: null,
    profile,
    frameCharacters: new Map(),
  };

  activeScrambles.set(target, state);

  const tick = () => {
    if (!activeScrambles.has(target)) return;

    const elapsed = performance.now() - state.startTime;
    const progress = Math.min(elapsed / profile.duration, 1);

    target.textContent = scrambleText(originalText, progress, profile, state);

    if (progress < 1) {
      state.timeoutId = window.setTimeout(tick, profile.frameInterval);
      return;
    }

    restoreTarget(target);
  };

  if (profile.delay > 0) {
    state.delayTimeoutId = window.setTimeout(() => {
      if (!activeScrambles.has(target)) return;

      state.startTime = performance.now();
      tick();
    }, profile.delay);
    return;
  }

  tick();
}

function restoreTarget(target) {
  const state = activeScrambles.get(target);

  if (!state) return;

  window.clearTimeout(state.timeoutId);
  window.clearTimeout(state.delayTimeoutId);
  target.textContent = state.originalText;
  target.classList.remove('is-scrambling', 'scramble-font-ready');
  activeScrambles.delete(target);
}

function scrambleText(text, progress, profile, state) {
  const characters = [...text];
  const mutableIndices = characters.reduce((indices, character, index) => {
    if (/[a-zA-Z0-9]/.test(character)) indices.push(index);
    return indices;
  }, []);

  if (mutableIndices.length === 0) return text;

  const easedProgress = profile.easing(progress);
  const resolveProgress = Math.min(1, easedProgress * profile.resolveBias);
  const initialScrambleCount = Math.min(
    profile.maxScrambleChars,
    Math.max(profile.minScrambleChars, Math.round(mutableIndices.length * profile.maxScrambleFraction))
  );
  const activeScrambleCount = Math.max(0, Math.ceil(initialScrambleCount * (1 - resolveProgress)));

  if (activeScrambleCount === 0) return text;

  const scrambleIndices = new Set(mutableIndices.slice(-activeScrambleCount));
  const updateProbability = getScrambleUpdateProbability(resolveProgress);

  for (const index of [...state.frameCharacters.keys()]) {
    if (!scrambleIndices.has(index)) {
      state.frameCharacters.delete(index);
    }
  }

  return characters
    .map((character, index) => {
      if (!scrambleIndices.has(index)) return character;

      const nextCharacter = getControlledScrambleCharacter(character, index, state.frameCharacters, updateProbability);

      return nextCharacter;
    })
    .join('');
}

function getScrambleCharacter(originalCharacter) {
  if (/[^a-zA-Z0-9]/.test(originalCharacter)) return originalCharacter;

  return SCRAMBLE_CHARACTERS[Math.floor(Math.random() * SCRAMBLE_CHARACTERS.length)];
}

function getControlledScrambleCharacter(originalCharacter, index, frameCharacters, updateProbability) {
  const cachedCharacter = frameCharacters.get(index);

  if (cachedCharacter && Math.random() >= updateProbability) {
    return cachedCharacter;
  }

  const nextCharacter = getScrambleCharacter(originalCharacter);
  frameCharacters.set(index, nextCharacter);
  return nextCharacter;
}

function getScrambleUpdateProbability(resolveProgress) {
  return (
    SCRAMBLE_UPDATE_PROBABILITY_START -
    (SCRAMBLE_UPDATE_PROBABILITY_START - SCRAMBLE_UPDATE_PROBABILITY_END) * resolveProgress
  );
}

function easeOutCubic(progress) {
  return 1 - (1 - progress) ** 3;
}

function easeInOutCubic(progress) {
  if (progress < 0.5) {
    return 4 * progress ** 3;
  }

  return 1 - ((-2 * progress + 2) ** 3) / 2;
}

async function loadScrambleFont() {
  if (!document.fonts) return;

  const fontQuery = `1em "${SCRAMBLE_FONT_FAMILY}"`;

  try {
    if (!hasDeclaredScrambleFont()) return;

    if (document.fonts.check(fontQuery)) {
      scrambleFontReady = true;
      return;
    }

    await document.fonts.load(fontQuery);
    scrambleFontReady = document.fonts.check(fontQuery);
  } catch {
    scrambleFontReady = false;
  }
}

function hasDeclaredScrambleFont() {
  return [...document.fonts].some((fontFace) => fontFace.family.replace(/"/g, '') === SCRAMBLE_FONT_FAMILY);
}
